<!--需求 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
				<div class="search-bar" @click="$router.push('/search?type=8')">
					<img src="../assets/search-icon.png" class="search-icon">
					<input placeholder="请输入搜索关键字" class="search-input" />
				</div>
			</div>
			<ul class="tab-list">
				<li>推荐</li>
				<li class="active">全部</li>
			</ul>
		</div>
		<div class="sub-tab-list-wrap">
			<ul class="sub-tab-list">
				<li :class="{active: params.is_over === 0}" @click="checkIsOver(0)">待解决</li>
				<li :class="{active: params.is_over === 1}" @click="checkIsOver(1)">已解决</li>
				<li :class="{active: params.is_over === 2}" @click="checkIsOver(2)">开源项目</li>
			</ul>

		</div>

    <div class="box">
      <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
        <van-list
            style="width: 100%"
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            :finished-text="list.length > 0 ? '没有更多了' : ''"
            @load="getList"
        >
          <ul class="list">
            <li v-for="(item, index) in list" :key="index" @click="$router.push(`/demand-details?demand_id=${item.id}`)">
              <div class="item-top">
                <img :src="item.cover.split('|')[0]" class="item-top-img">
                <div class="item-top-sidebar">
                  <p class="item-top-name">{{ item.title }}</p>
                  <p class="item-top-msg" v-html="item.content"></p>
                </div>
              </div>
              <div class="item-bottom">
                <div class="item-bottom-row">
                  <img :src="item.headimg" class="item-bottom-avatar" v-if="item.headimg">
                  <img src="../assets/avatar.png" class="item-bottom-avatar" v-else>
                  {{ item.user_name || '' }}
                </div>
                <span class="price">¥{{ item.money }}</span>
              </div>
              <span class="item-tag" v-if="item.is_over === 0">待解决</span>
              <span class="item-tag blue" v-if="item.is_over === 1">已解决</span>
              <span class="item-tag green" v-if="item.is_over === 2">开源项目</span>
            </li>
            <div class="normal-box-small" v-if="list.length === 0">
              <img src="../assets/normal.png">
              暂无数据
            </div>
          </ul>
        </van-list>
      </van-pull-refresh>
    </div>

		<!-- 发布弹窗 -->
		<van-overlay :show="show" z-index="99999">
			<div class="window">
				<div class="window-top">
					<button type="button" class="window-btn"
						@click.stop="show = false; $router.push('/demand-release')">
						<img src="../assets/icon-68.png">发布有偿需求
					</button>
					<button type="button" class="window-btn del"
						@click="show = false; $router.push('/demand-release-write')">
						<img src="../assets/icon-67.png">发布无偿需求
					</button>
				</div>
				<div class="window-btn-box">
					<button type="button" @click="show = false">
						<img src="../assets/close-icon3.png">
					</button>
				</div>
			</div>
		</van-overlay>


		<div class="float-box" @click="show = true">
			<img src="../assets/icon-66.png">
		</div>

	</div>
</template>

<script>
import {ActivityService, DemandService} from "@/common/service";

  export default {
		data() {
			return {
				show: false,

        params: {
          is_over: 0,  // 是否解决或开源【0否，1是，2开源】
          page: 1,  // 页数
          page_num: 10,  // 每页数
        },
        list: [],
        loading: false,
        finished: false,

        refreshLoading: false, // 下拉刷新
			};
		},
		mounted() {
      this.getList()
		},
		methods: {
      checkIsOver(val) {
        if (this.loading) return;
        this.params.is_over = val;
        this.params.page = 1;
        this.finished = false;
        this.getList();
      },

      onRefresh() {
        this.params.page = 1;
        this.finished = false;
        this.getList();
      },
      getList() {
        this.loading = true;
        DemandService.getDemandList(this.params)
            .then(({ data }) => {
              const list = data.list;
              this.list = this.params.page === 1 ? list : [...this.list, ...list];
              if (list.length < this.params.page_num) {
                this.finished = true;
              } else {
                this.params.page++;
              }
            }).finally(() => {
          this.loading = false;
          this.refreshLoading = false;
        }).catch(() => this.finished = true);
      },
		},
	}
</script>

<style scoped>
.box{
  width: 100%;
  height: calc(var(--vh) * 100 - 136px);
  overflow: auto;
}
	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 84px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		z-index: 499;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.return-img {
		width: 20px;
		margin-right: 10px;
	}

	.search-bar {
		width: calc(100% - 65px);
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 16px;
		margin-right: 10px;
	}

	.search-input {
		flex: 1;
		font-size: 15px;
	}

	.search-input::placeholder {
		color: #B6B6B6;
	}

	.tab-list {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		position: relative;
	}

	.postion-cart-box {
		position: absolute;
		right: 25px;
		top: 50%;
		transform: translate(0, -50%);
	}

	.postion-cart {
		width: 22px;
	}

	.postion-cart-num {
		position: absolute;
		right: -5px;
		top: -5px;
		color: #FFFFFF;
		font-size: 10px;
		height: 14px;
		line-height: 14px;
		min-width: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FF4954;
		border-radius: 50%;
		padding: 0 1px;
		box-sizing: border-box;
	}

	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		color: #888888;
		position: relative;
	}

	.tab-list>li.active {
		font-size: 18px;
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}

	.sub-tab-list-wrap {
		width: 100%;
		height: 52px;
		display: flex;
		align-items: center;
		position: fixed;
		top: 84px;
		left: 0;
		z-index: 500;
		background-color: #F4F4F4;
	}

	.sub-tab-list {
		width: 100%;
		white-space: nowrap;
		overflow: auto;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.sub-tab-list>li {
		display: inline-block;
		width: 26%;
		margin-right: 11%;
		text-align: center;
		height: 28px;
		line-height: 28px;
		font-size: 13px;
		color: #666666;
		background-color: #EAEBED;
		border-radius: 30px;
	}

	.sub-tab-list>li:last-child {
		margin-right: 0;
	}

	.sub-tab-list>li.active {
		color: #2A63F3;
		border: 1px solid #2A63F3;
		background-color: #DCE6FF;
	}

	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin: 136px 0 0;
		box-sizing: border-box;
		background-color: #F4F4F4;
		overflow: auto;
	}

	.video-list>li {
		width: calc(50% - 7.5px);
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		margin-bottom: 12px;
		border-radius: 10px;
		box-shadow: 0 1px 16px rgba(0, 0, 0, 0.12);
		overflow: hidden;
	}

	.video-list>li:nth-child(7n + 1) {
		width: 100%;
	}

	.float-box {
		position: fixed;
		right: 15px;
		bottom: 80px;
	}

	.float-box>img {
		width: 64px;
	}


	.list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		display: flex;
		flex-direction: column;
		border-radius: 12px;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		padding: 0 10px;
		box-sizing: border-box;
		position: relative;
		margin-bottom: 12px;
	}

	.item-top {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0 10px;
		box-sizing: border-box;
	}



	.item-tag {
		width: fit-content;
		position: absolute;
		right: 0;
		top: 0;
		color: #FFFFFF;
		font-size: 12px;
		height: 20px;
		line-height: 20px;
		display: flex;
		align-items: center;
		padding: 0 10px;
		background: #FF9833;
		border-radius: 0 8px 0 8px;
	}

	.item-tag.blue {
		background-color: #2A63F3;
	}

  .item-tag.green {
    background-color: #1FB759;
  }

	.item-top-img {
		width: 60px;
		height: 60px;
		object-fit: cover;
		border-radius: 8px;
		margin-right: 10px;
	}

	.item-top-sidebar {
		flex: 1;
		height: 60px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.item-top-name {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #222222;
		font-size: 12px;
		font-weight: bold;
	}

	.item-top-msg {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #999999;
		font-size: 12px;
	}

	.item-bottom {
		width: 100%;
		height: 39px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.item-bottom-row {
		flex: 1;
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.item-bottom-avatar {
		width: 18px;
		height: 18px;
		object-fit: cover;
		border-radius: 50%;
		margin-right: 6px;
	}

	.price {
		color: #FF4954;
		font-size: 14px;
		font-weight: bold;
	}

	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 120px 0;
	}

	.normal-box-small>img {
		width: 150px;
		margin-bottom: 9px;
	}

	.window {
		width: 100%;
		display: flex;
		flex-direction: column;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 99999999;
	}

	.window-top {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.window-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-weight: 500;
		font-size: 16px;
		margin-bottom: 40px;
	}

	.window-btn>img {
		width: 60px;
		margin-right: 10px;
	}

	.window-btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 40px 0;
		box-sizing: border-box;
	}

	.window-btn-box>button {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.window-btn-box>button>img {
		width: 40px;
	}
</style>
